import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * True when a rejected promise is an aborted request rather than a real failure.
 * Axios reports cancellation as `ERR_CANCELED` / `CanceledError`; a bare
 * `AbortController` on fetch reports `AbortError`. Callers use this to stay
 * silent instead of toasting an error the user caused on purpose.
 */
export function isAbortError(err) {
  return (
    err?.code === 'ERR_CANCELED' ||
    err?.name === 'CanceledError' ||
    err?.name === 'AbortError'
  );
}
